module.exports = __webpack_public_path__ + "img/watch-fitness.051cb765.svg";